import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { SimpleDataContainer } from "../ConfirmModal/confirmModalComponents";
import InfoContainer from "./InfoContainer";

const styles = {
  container: {
    padding: "0 30px 30px 30px",
  },
};

export const FormulaInfo = ({
  request,
  setParams,
}) => {
  const {
    cementType,
    fck,
    formulaCode,
    gravelType,
    slump,
  } = request || {};

  const initialValues = {
    cementType,
    fck,
    formulaCode,
    gravelType,
    slump,
  };

  const [formState, setFormState] = useState(initialValues);
  const backgroundColor = "#f6f8ff";

  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      ...formState,
    }));
  }, [formState]);

  const fields = [
    { title: "Fck", key: "fck" },
    { title: "Slump", key: "slump" },
    { title: "Brita", key: "gravelType" },
    { title: "Cimento", key: "cementType" },
  ];

  const handleFieldChange = (key, value) => {
    setFormState((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div style={styles.container}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <h3>Informações do traço</h3>
      </div>

      <SimpleDataContainer style={{ justifyContent: "flex-start", backgroundColor, paddingBottom: "20px" }}>
        <Col key="formulaCode" sm={6} md={6} lg={4}>
          <InfoContainer
            title="Código do traço"
            value={formState.formulaCode}
            canEdit={!initialValues.formulaCode}
            handleChange={(value) => handleFieldChange("formulaCode", value)}
          />
        </Col>
        {fields.map(({ title, key }) => (
          <Col key={key} sm={4} md={4} lg={2}>
            <InfoContainer
              title={title}
              value={formState[key]}
              canEdit={!initialValues[key]}
              handleChange={(value) => handleFieldChange(key, value)}
            />
          </Col>
        ))}
      </SimpleDataContainer>
    </div>
  );
};
